import { trackWithGoogleAnalytics } from '../shared/trackers/trackWithGoogleAnalytics';

interface IRefundEvent {
	transactionId: string;
}

/**
 * https://developers.google.com/analytics/devguides/collection/gtagjs/enhanced-ecommerce#measure_refunds
 */
export function trackRefund({ transactionId }: IRefundEvent) {
	trackWithGoogleAnalytics('event', 'refund', {
		transaction_id: transactionId,
	});
}
